import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getMobilebanners,
  deleteMobilebanner,
  getNextMobilebanners,
  getPreviousMobilebanners,
} from "../../store/actions/mobilebanners_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/mobilebanners_enum";
import DataTable from "../../components/common/DataTable";
const AllMobilebanners = ({
  getMobilebanners,
  deleteMobilebanner,
  getNextMobilebanners,
  getPreviousMobilebanners,
  mobilebanner: { loading, mobilebanners },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteMobilebanner(deleteEntry);
      }
      getMobilebanners({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (mobilebanners && mobilebanners.length === LIMIT) {
      const lastMobilebanner = mobilebanners[mobilebanners.length - 1];
      getNextMobilebanners({ last: lastMobilebanner });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastMobilebanner = mobilebanners[0];
      getPreviousMobilebanners({
        first: lastMobilebanner,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getMobilebanners({ term: term, termField: termField });
    }
  };
  const deleteMobilebannerClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getMobilebanners({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Mobilebanners"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Mobilebanner"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="mobilebanners" title="Mobilebanner" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={mobilebanners}
                      field={"mobilebanners"}
                      page={page}
                      deleteBtnClicked={deleteMobilebannerClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={mobilebanners}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ mobilebanner: state.mobilebanner });

const mapDispatchToProps = {
  getMobilebanners,
  deleteMobilebanner,
  getNextMobilebanners,
  getPreviousMobilebanners,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllMobilebanners);
